const AboutSection = () => {
  return (
    <section id="hakkimizda" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 gap-12">
            {/* Content */}
            <div>
              <div className="inline-block px-4 py-2 bg-beige/20 rounded-full mb-6">
                <span className="text-wood-dark font-medium">Hakkımızda</span>
              </div>
              
              <h2 className="text-4xl lg:text-5xl font-bold text-wood-dark mb-6">
                İzmir'in Güvenilir Tadilat Firması
              </h2>
              
              <div className="space-y-4 text-lg text-gray-700 leading-relaxed">
                <p>
                  İzmir Tadilat Firması olarak, 15 yılı aşkın tecrübemizle ev ve işyeri tadilat projelerinizde yanınızdayız. Mutfak tadilatından banyo yenileme, komple daire tadilatından cafe ve restoran projelerine kadar geniş bir yelpazede hizmet sunuyoruz.
                </p>
                
                <p>
                  Uzman kadromuz ve kaliteli malzeme seçimimiz ile projelerinizi zamanında ve bütçenize uygun şekilde tamamlıyoruz. Müşteri memnuniyeti odaklı çalışma prensibimiz ile İzmir'in her noktasında hizmet veriyoruz.
                </p>
                
                <p>
                  Mimari tasarımdan uygulamaya, dış cephe çalışmalarından çatı ve izolasyon işlerine kadar tüm tadilat ihtiyaçlarınız için tek adres. Profesyonel ekibimiz, modern teknikler ve kaliteli işçilik ile hayalinizdeki mekanı gerçeğe dönüştürüyoruz.
                </p>
              </div>

              <div className="mt-10 flex flex-wrap gap-4">
                <a
                  href="/hizmetler"
                  className="inline-flex items-center space-x-2 px-8 py-4 bg-wood-dark hover:bg-wood text-white rounded-full font-medium transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  <span>Hizmetlerimiz</span>
                  <i className="ri-arrow-right-line"></i>
                </a>
                
                <a
                  href="/iletisim"
                  className="inline-flex items-center space-x-2 px-8 py-4 bg-beige hover:bg-beige/80 text-wood-dark rounded-full font-medium transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  <span>İletişime Geçin</span>
                  <i className="ri-phone-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
